import React from 'react';
import {
  Snackbar,
  Paper,
  Typography,
  Button,
  IconButton,
  Stack,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useVersionCheck } from '../hooks/useVersionCheck';

export default function VersionUpdatePopup() {
  const { t } = useTranslation();
  const { hasNewVersion, dismissUpdate, refreshPage } = useVersionCheck();

  return (
    <Snackbar
      open={hasNewVersion}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Paper
        elevation={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
        }}
      >
        <Typography variant="body2" fontWeight={500}>
          {t('versionUpdate.message', 'Yeni versiyon mevcut')}
        </Typography>
        <Stack direction="row" spacing={0.5}>
          <Button
            size="small"
            variant="contained"
            onClick={refreshPage}
            startIcon={<RefreshIcon sx={{ fontSize: 18 }} />}
            sx={{
              bgcolor: 'rgba(255,255,255,0.2)',
              color: 'inherit',
              textTransform: 'none',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
            }}
          >
            {t('versionUpdate.refresh', 'Yenile')}
          </Button>
          <IconButton
            size="small"
            onClick={dismissUpdate}
            sx={{ color: 'inherit', opacity: 0.7, '&:hover': { opacity: 1 } }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Paper>
    </Snackbar>
  );
}
